import { PartialArticle } from '@doist/help-center-utils'
import { LazyImage, Text } from '@doist/marketist'

import cn from 'classnames'
import { useTranslation } from 'next-i18next'

import { ArticleButton } from '../ArticleButton/ArticleButton'

import emptyIllus from './empty-illus@2x.jpg'

import css from './ArticleGrid.module.css'

export type ArticleGridProps = {
    title: string
    articles: PartialArticle[]
}

export function ArticleGrid({
    title,
    articles,
    className,
    ...rest
}: ArticleGridProps & React.HTMLAttributes<HTMLDivElement>) {
    const { t } = useTranslation('helpcenter')
    return (
        <div className={cn(css.articleGrid, className)} {...rest}>
            {articles.length === 0 ? (
                <div className={css.empty}>
                    <LazyImage src={emptyIllus} />
                    <Text className={css.title} size="body-lg">
                        {t('noResultsFor', { title })}
                    </Text>
                    <Text size="body-base">{t('tryAnotherSearch')}</Text>
                </div>
            ) : (
                <ul>
                    {articles.map((article) => (
                        <li key={article.id}>
                            <ArticleButton
                                title={article.title}
                                href={`/help/articles/${article.id}`}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}
